export default "__VITE_ASSET__qtSW1fFt__"